/* eslint-disable array-callback-return */
import React from 'react';

import { BaSeBackendNoSignalPage, BaSeDialogContext, BaSeIcon, BaSeInput, BaSeTheme } from '@base/react';

import Spinner from 'react-spinner-material';

import CarrosseisModel from './carrosseis.model';
import './style.scss';
import { FaCheck, FaCopy, FaPen, FaRegBell, FaTrash, } from 'react-icons/fa';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import download from '../../images/download.png';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import ReactExport from 'react-export-excel';
import { formatDateToBR } from '../../utils/time';
import { formatDefaultValueSelect } from '../../utils/mask';

import columns from './columns';
import { AddCarrossel } from './addCarrossel/addCarrossel';
import { ReoderCarrossel } from './reoderCarrossel/reorderCarrossel';
import { Pagination } from '../../components/Pagination';

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const optionsLinesPorPage = [10, 25, 50, 100];

export const DEFAULT_VALUE_SELECIONE = 'Selecione';

const Carrosseis = () => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const {
    data,
    isLoading,
    error,
    typeScreen,
    setTypeScreen,
    filters,
    setFilters,
    isCPF,
    setIsCPF,
    selectedRow,
    setSelectedRow,
    filtersSelectedValues,
    allValuesOptions,
    updateSelectedValues,
    deleteCarrossel,
    setActionDone,
    setActionInclude,
    updateCarrossel,
    filterOptions,
    getCidades,
    cidades,
    // trateExcelData,
    cnaesFiltered,
    setCnaesFiltered,
    cleanSelectedFilters,
    // time,
    downloadingSheet,
    downloadedSheet,
    downloadFile,
    // tratedCols,
    aprovationValue,
  } = CarrosseisModel();

  const renderHeader = () => {
    return (
        <div className="modal-carrossel">
          <div className="modal-flex-direction-row">
            <FaRegBell size={40} color="#ffffff" />
            <h2 className="text-color-branco-titulo">Carrosséis</h2>
            <div className="div-acoes-push">
              <div className="icons-acoes-push">
                <BaSeIcon
                    onClick={() => setTypeScreen(5)}
                    name="repeat"
                    description="Adicionar funcionalidade"
                    color="#ffffff"
                    size={50}
                />

                <BaSeIcon
                    onClick={() => setTypeScreen(2)}
                    name="plus-circle"
                    description="Adicionar funcionalidade"
                    color="#ffffff"
                    size={50}
                />
              </div>
            </div>
          </div>
        </div>
    );
  };

  const renderFiltros = () => {
    return (
        <>
          <div className="filters-content">
            <div
                className="filter-container"
                style={{ borderBottom: '1px solid #33CC99' }}
            >
              <h3 className="subTitle-carrossel">Gerenciar</h3>
              <div className="input-content">
                <BaSeInput
                    label=""
                    iconButton={{
                      name: 'search',
                      type: 'primary-default',
                      typeButton: 'base-icon',
                      value: 'Default',
                      color: '#33CC99',
                    }}
                    value={filtersSelectedValues?.oqueVoceProcura ?? ''}
                    onChange={(value) =>
                        updateSelectedValues('oqueVoceProcura', value)
                    }
                    placeholder="Digite o que você procura..."
                    size="big"
                    typeInput="text"
                    width="100%"
                />
              </div>
            </div>
          </div>

          <div className="info">
            <div className="results">
              <Accordion style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                  <BaSeIcon
                      name="filter"
                      color="#33CC99"
                      size={25}
                      description="Ícone de filtro"
                  />
                  <text
                      className="title-accordion-pushs"
                      style={{ color: '#33CC99', marginTop: '4px' }}
                  >
                    Filtrar
                  </text>
                  <div
                      className="close-filter-container"
                      onClick={(e) => {
                        e.stopPropagation();
                        cleanSelectedFilters();
                        setFilters({ type: 'filters', data: {} });
                      }}
                  >
                    <BaSeIcon
                        name="close"
                        size={10}
                        color="#33CC99"
                        description="Limpar filtros"
                    />
                    <text className="title-accordion-component-filter-carrossel">
                      Limpar filtros
                    </text>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionDetails-container-carrossel">
                    <div className="content-left">
                      {/* PRIMEIRA LINHA */}
                      <div className="subContent-tipoPerfil">
                        {/* TIPO */}
                        <div className="select-tipo-filter">
                          <div>
                            <label htmlFor="input-tipo" className="label-style">
                              Tipo
                            </label>
                          </div>
                          <select
                              id="input-tipo"
                              value={filtersSelectedValues?.tipo ?? ''}
                              className="correct-color tipo-filter-carrossel"
                              onChange={(event) => {
                                const tipo = event.target.value;
                                updateSelectedValues('tipo', tipo);
                                setFilters({
                                  type: 'filters',
                                  data: { ...filters.filters, tipo: tipo },
                                });
                              }}
                          >
                            <option value={null}>
                              {DEFAULT_VALUE_SELECIONE}
                            </option>
                            {filterOptions?.tipos?.map((tp) => (
                                <option key={tp} value={tp} title={tp}>
                                  {formatDefaultValueSelect(tp)}
                                </option>
                            ))}
                          </select>
                        </div>

                        {/* PERFIL */}
                        <div className="select-perfil-filter">
                          <div>
                            <label htmlFor="input-perfil" className="label-style">
                              Perfis
                            </label>
                          </div>

                          <select
                              id="input-perfil"
                              value={filtersSelectedValues?.perfis ?? ''}
                              className="correct-color perfis-filter-carrossel"
                              onChange={(event) => {
                                const id = event.target.value;
                                const recoveryPerfil = filterOptions.perfis.find(
                                    (each) => each.id === parseInt(id)
                                );
                                updateSelectedValues('perfis', id);
                                setFilters({
                                  type: 'filters',
                                  data: {
                                    ...filters.filters,
                                    perfis: [recoveryPerfil],
                                  },
                                });
                              }}
                          >
                            <option value={null}>
                              {DEFAULT_VALUE_SELECIONE}
                            </option>
                            {filterOptions?.perfis?.map((pf) => (
                                <option value={pf.id} title={pf.nome}>
                                  {formatDefaultValueSelect(pf.nome)}
                                </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* SEGUNDA LINHA */}
                      <div className="subContent-data">
                        {/* ATRIBUTOS DATA */}
                        <div>
                          <div>
                            <label
                                htmlFor="input-atributos-data"
                                className="label-style"
                            >
                              Data
                            </label>
                          </div>
                          <select
                              id="input-atributos-data"
                              value={filtersSelectedValues?.tipoAtributoData ?? ''}
                              className="correct-color data-carrossel-filter"
                              onChange={(event) => {
                                const nomeAtributo = event.target.value;
                                const recoveryTipoAtributoData =
                                    filterOptions.atributosData.find(
                                        (each) => each.nomeAtributo === nomeAtributo
                                        // each.nomeAtributo === parseInt(nomeAtributo)
                                    );
                                updateSelectedValues(
                                    'tipoAtributoData',
                                    nomeAtributo
                                );
                                setFilters({
                                  type: 'filters',
                                  data: {
                                    ...filters.filters,
                                    tipoAtributoData: recoveryTipoAtributoData,
                                  },
                                });
                              }}
                          >
                            <option value={null}>
                              {DEFAULT_VALUE_SELECIONE}
                            </option>
                            {filterOptions?.atributosData?.map((data) => (
                                <option
                                    key={data.nomeAtributo}
                                    value={data.nomeAtributo}
                                    title={data.descricao}
                                >
                                  {data.descricao}
                                </option>
                            ))}
                          </select>
                        </div>

                        {/* DATA INICIO-FIM */}
                        <div className="data-inicioFim-area">
                          {/* DATA INICIO */}
                          <div>
                            <div>
                              <label
                                  htmlFor="input-data-inicio"
                                  className="label-style"
                                  style={{
                                    color:
                                        filtersSelectedValues?.mes ||
                                        filtersSelectedValues?.ano
                                            ? '#bdbcbc'
                                            : '#9b9b9b',
                                  }}
                              >
                                Data início
                              </label>
                            </div>
                            <input
                                disabled={
                                    filtersSelectedValues?.mes ||
                                    filtersSelectedValues?.ano
                                }
                                style={{
                                  borderColor:
                                      filtersSelectedValues?.mes ||
                                      filtersSelectedValues?.ano
                                          ? '#cdcdcd'
                                          : '#9b9b9b',
                                  color:
                                      filtersSelectedValues?.mes ||
                                      filtersSelectedValues?.ano
                                          ? '#bdbcbc'
                                          : '#9b9b9b',
                                }}
                                value={filtersSelectedValues?.dataInicial ?? ''}
                                id="input-data-inicio"
                                name="dataInicio"
                                type="date"
                                max={'9999-12-31'}
                                // className="date-picker data-inicio-filter-carrossel"
                                onChange={(event) => {
                                  updateSelectedValues(
                                      'dataInicial',
                                      event.target.value
                                  );
                                  setFilters({
                                    type: 'filters',
                                    data: {
                                      ...filters.filters,
                                      dataInicial: event.target.value,
                                    },
                                  });
                                }}
                            />
                          </div>

                          {/* DATA FIM */}
                          <div>
                            <div>
                              <label
                                  htmlFor="input-data-fim"
                                  className="label-style"
                                  style={{
                                    color:
                                        filtersSelectedValues?.mes ||
                                        filtersSelectedValues?.ano
                                            ? '#bdbcbc'
                                            : '#9b9b9b',
                                  }}
                              >
                                Data fim
                              </label>
                            </div>
                            <input
                                disabled={
                                    filtersSelectedValues?.mes ||
                                    filtersSelectedValues?.ano
                                }
                                style={{
                                  borderColor:
                                      filtersSelectedValues?.mes ||
                                      filtersSelectedValues?.ano
                                          ? '#bdbcbc'
                                          : '#9b9b9b',
                                  color:
                                      filtersSelectedValues?.mes ||
                                      filtersSelectedValues?.ano
                                          ? '#bdbcbc'
                                          : '#9b9b9b',
                                }}
                                value={filtersSelectedValues?.dataFinal ?? ''}
                                id="dataFim"
                                name="dataFim"
                                type="date"
                                max={'9999-12-31'}
                                // className="date-picker data-fim-filter-carrossel"
                                onChange={(event) => {
                                  updateSelectedValues(
                                      'dataFinal',
                                      event.target.value
                                  );
                                  setFilters({
                                    type: 'filters',
                                    data: {
                                      ...filters.filters,
                                      dataFinal: event.target.value,
                                    },
                                  });
                                }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* TERCEIRA LINHA */}
                      <div className="subContent-UfCidade">
                        {/* UF CIDADE */}
                        <div className="uf-cidade-row">
                          <div className="ufs-area">
                            <div className="label-style">
                              <label htmlFor="input-ufs">UFs</label>
                            </div>

                            <select
                                id="input-ufs"
                                value={filtersSelectedValues?.ufs ?? ''}
                                className="correct-color uf-filter-corrossel"
                                onChange={(event) => getCidades(event.target.value)}
                            >
                              <option value={null}>Todas</option>
                              {filterOptions?.ufs?.map((uf) => (
                                  <option value={uf.id} title={uf.sigla}>
                                    {uf.sigla}
                                  </option>
                              ))}
                            </select>
                          </div>

                          <div className="cidade-area">
                            <div className="label-style">
                              <label htmlFor="input-cidade">Cidade</label>
                            </div>
                            <select
                                value={filtersSelectedValues?.cidades ?? ''}
                                className="correct-color"
                                onChange={(event) => {
                                  const id = event.target.value;
                                  const recovery = cidades.find(
                                      (each) => each.id === parseInt(id)
                                  );

                                  setFilters({
                                    type: 'filters',
                                    data: {
                                      ...filters.filters,
                                      cidades: [recovery],
                                    },
                                  });
                                }}
                            >
                              <option value={null}>
                                {DEFAULT_VALUE_SELECIONE}
                              </option>
                              {cidades.map((cidade) => (
                                  <option value={cidade.id} title={cidade.nome}>
                                    {cidade.nome}
                                  </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        {/* TIPO USUÀRIO */}
                        <div className="tipo-user-row">
                          <div className="label-style">
                            <label>Tipo de usuário</label>
                          </div>
                          <div className="inside-user-row">
                            <div className="cpf-user-row">
                              <input
                                  id="label-input-cpf"
                                  type="radio"
                                  value={isCPF}
                                  checked={isCPF}
                                  onChange={() => setIsCPF(true)}
                              />
                              <label htmlFor="label-input-cpf">CPF</label>
                            </div>

                            <div className="cnpj-user-row">
                              <input
                                  id="label-input-cnpj"
                                  type="radio"
                                  value={isCPF}
                                  checked={!isCPF}
                                  onChange={() => setIsCPF(false)}
                              />
                              <label htmlFor="label-input-cnpj">CNPJ</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* QUARTA LINHA */}
                      <div className="subContent-Users">
                        <div>
                          <label htmlFor="input-usersQue" className="label-style">
                            Usuários que
                          </label>
                        </div>
                        <select
                            id="input-usersQue"
                            value={filtersSelectedValues?.ufs ?? ''}
                            className="correct-color"
                            onChange={(event) => {
                              const uq = event.target.value;
                              updateSelectedValues('usuariosQue', uq);
                              setFilters({
                                type: 'filters',
                                data: { ...filters.filters, usuariosQue: uq },
                              });
                            }}
                        >
                          <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                          {filterOptions?.usuariosQue?.map((uq) => (
                              <option value={uq} title={uq}>
                                {formatDefaultValueSelect(uq)}
                              </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="content-right">
                      <div className="subcontent-mes-ano">
                        <div>
                          <div className="label-style">
                            <label
                                htmlFor="input-mes"
                                style={{
                                  color:
                                      filtersSelectedValues?.dataInicial ||
                                      filtersSelectedValues?.dataFinal
                                          ? '#bdbcbc'
                                          : '#9b9b9b',
                                }}
                            >
                              Mês
                            </label>
                          </div>
                          <select
                              disabled={
                                  filtersSelectedValues?.dataInicial ||
                                  filtersSelectedValues?.dataFinal
                              }
                              value={filtersSelectedValues?.mes ?? ''}
                              className="correct-color mes-filter-carrossel"
                              id="input-mes"
                              onChange={(event) => {
                                const mes = event.target.value;
                                updateSelectedValues('mes', mes);
                                setFilters({
                                  type: 'filters',
                                  data: { ...filters.filters, mes: mes },
                                });
                              }}
                          >
                            <option value={null}>
                              {DEFAULT_VALUE_SELECIONE}
                            </option>
                            {filterOptions?.meses?.map((mes) => (
                                <option value={mes} title={mes}>
                                  {formatDefaultValueSelect(mes)}
                                </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <div className="label-style">
                            <label
                                htmlFor="input-ano"
                                style={{
                                  color:
                                      filtersSelectedValues?.dataInicial ||
                                      filtersSelectedValues?.dataFinal
                                          ? '#bdbcbc'
                                          : '#9b9b9b',
                                }}
                            >
                              Ano
                            </label>
                          </div>
                          <select
                              disabled={
                                  filtersSelectedValues?.dataInicial ||
                                  filtersSelectedValues?.dataFinal
                              }
                              id="input-ano"
                              value={filtersSelectedValues?.ano ?? ''}
                              className="correct-color ano-filter-carrossel"
                              onChange={(event) => {
                                const ano = event.target.value;
                                updateSelectedValues('ano', ano);
                                setFilters({
                                  type: 'filters',
                                  data: { ...filters.filters, ano: parseInt(ano) },
                                });
                              }}
                          >
                            <option value={''}>{DEFAULT_VALUE_SELECIONE}</option>
                            {filterOptions?.anos?.map((ano) => (
                                <option value={ano} title={ano}>
                                  {ano}
                                </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="subcontent-segmentos">
                        {/* SEGMENTOS */}
                        <div>
                          {!isCPF && (
                              <>
                                <div>
                                  <label className="label-style">Segmentos</label>
                                </div>
                                <select
                                    value={filtersSelectedValues?.segmentos ?? ''}
                                    className="correct-color"
                                    onChange={(event) => {
                                      const id = event.target.value;
                                      const recoverySegmentos =
                                          filterOptions.segmentos.find(
                                              (each) => each.id === parseInt(id)
                                          );
                                      updateSelectedValues('segmentos', id);

                                      setCnaesFiltered(
                                          id !== DEFAULT_VALUE_SELECIONE
                                              ? recoverySegmentos.cnaes
                                              : []
                                      );
                                      setFilters({
                                        type: 'filters',
                                        data: {
                                          ...filters.filters,
                                          segmentos: [recoverySegmentos],
                                        },
                                      });
                                    }}
                                >
                                  <option value={null}>
                                    {DEFAULT_VALUE_SELECIONE}
                                  </option>
                                  {filterOptions.segmentos &&
                                      filterOptions.segmentos.map((seg) => (
                                          <option value={seg.id} title={seg.nome}>
                                            {seg.nome}
                                          </option>
                                      ))}
                                </select>
                              </>
                          )}
                        </div>

                        {/* CNAE */}
                        <div>
                          {!isCPF && (
                              <>
                                <div>
                                  <label className="label-style">CNAE</label>
                                </div>
                                <select
                                    value={filtersSelectedValues?.cnaes ?? ''}
                                    className="correct-color"
                                    onChange={(event) => {
                                      const id = event.target.value;
                                      const recoveryCnae = cnaesFiltered.find(
                                          (each) => each.id === parseInt(id)
                                      );
                                      updateSelectedValues('cnaes', id);
                                      setFilters({
                                        type: 'filters',
                                        data: {
                                          ...filters.filters,
                                          cnaes: [recoveryCnae],
                                        },
                                      });
                                    }}
                                >
                                  <option value={null}>
                                    {DEFAULT_VALUE_SELECIONE}
                                  </option>
                                  {cnaesFiltered &&
                                      cnaesFiltered
                                          .sort((a, b) =>
                                              a.descricao.localeCompare(b.descricao)
                                          )
                                          .map((cnae) => (
                                              <option
                                                  value={cnae.id}
                                                  title={cnae.descricao}
                                              >
                                                {cnae.descricao}
                                              </option>
                                          ))}
                                </select>
                              </>
                          )}
                        </div>

                        {/* PORTE */}
                        <div>
                          {!isCPF && (
                              <>
                                <div>
                                  <label className="label-style">Porte</label>
                                </div>
                                <select
                                    value={filtersSelectedValues?.portes ?? ''}
                                    className="correct-color"
                                    onChange={(event) => {
                                      const id = event.target.value;
                                      const recoveryPortes =
                                          filterOptions.portes.find(
                                              (each) => each.id === parseInt(id)
                                          );
                                      updateSelectedValues('portes', id);
                                      setFilters({
                                        type: 'filters',
                                        data: {
                                          ...filters.filters,
                                          portes: [recoveryPortes],
                                        },
                                      });
                                    }}
                                >
                                  <option value={null}>
                                    {DEFAULT_VALUE_SELECIONE}
                                  </option>
                                  {filterOptions?.portes?.map((porte) => (
                                      <option
                                          value={porte.id}
                                          title={porte.nomePorte}
                                      >
                                        {porte.nomePorte}
                                      </option>
                                  ))}
                                </select>
                              </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <div className="attention">
                <div class="info-container">
                  <BaSeIcon
                      name="info-circle"
                      size={28}
                      color="#ff0000"
                      description="Página de gerenciamento"
                  />
                  <text>
                    Existem{' '}
                    <strong style={{ color: '#ff0000', fontWeight: 'bold' }}>
                      {' '}
                      {aprovationValue?.PENDENTE ?? 0}{' '}
                    </strong>
                    {''}
                    itens aguardando aprovação.
                  </text>
                  {/* <text>
                  Existem{' '}
                  <strong style={{ color: '#33CC99', fontWeight: 'bold' }}>
                    {aprovationValue?.PENDENTE ?? 0}{' '}
                  </strong>
                  funcionalidades à serem aprovadas e{' '}
                  <strong style={{ color: '#33CC99', fontWeight: 'bold' }}>
                    {aprovationValue?.APROVADO ?? 0}
                  </strong>{' '}
                  aprovados.
                </text> */}
                </div>
                <div className="legenda">
                  <div
                      className="legenda-buttons"
                      onClick={() => {
                        updateSelectedValues('status', 'APROVADO');
                        setFilters({
                          type: 'filters',
                          data: { ...filters.filters, status: 'APROVADO' },
                        });
                      }}
                  >
                    <FaCheck size={20} color="#00ff00" />
                    <text>Aprovada</text>
                  </div>
                  <div
                      className="legenda-buttons"
                      onClick={() => {
                        updateSelectedValues('status', 'PENDENTE');
                        setFilters({
                          type: 'filters',
                          data: { ...filters.filters, status: 'PENDENTE' },
                        });
                      }}
                  >
                    <FaCheck size={20} color="#ff0000" />
                    <text>Aguardando aprovação</text>
                  </div>
                </div>
              </div>

              <div className="flex container-excel-icon">
                <div>
                  {/* <p className="text-color-azul-ref margin-bottom-20 ">
                  Ref:{' '}
                  {time && `${time.split(' ')[0]} às ${time.split(' ')[1]}`}
                </p> */}
                  <p
                      className="text-color-carrossel margin-bottom-20 "
                      style={{
                        fontWeight: 'bold',
                        marginTop: '2rem',
                        marginLeft: '0.3rem',
                      }}
                  >
                    {data?.totalElements ?? 0}
                    <strong className="find-results">
                      {' '}
                      resultados encontrados{' '}
                    </strong>
                  </p>
                </div>

                {!downloadedSheet && !downloadingSheet && (
                    <img
                        className="xls"
                        alt="imagem"
                        src={download}
                        onClick={downloadFile}
                        style={{ width: '3.1rem' }}
                    />
                )}
                {!downloadedSheet && downloadingSheet && (
                    // <div className="loader"></div>
                    <Spinner
                        radius={40}
                        color={'#33cc99'}
                        stroke={2}
                        visible={true}
                    />
                )}
                {/*{downloadedSheet && (*/}
                {/*    <ExcelFile*/}
                {/*        filename={`Carrosseis-${formatDateToBR(new Date())}`}*/}
                {/*        element={*/}
                {/*          <img*/}
                {/*              className="xls"*/}
                {/*              alt="imagem"*/}
                {/*              src={xlsImagem}*/}
                {/*              style={{ width: '3.1rem' }}*/}
                {/*          />*/}
                {/*        }*/}
                {/*    >*/}
                {/*      <ExcelSheet data={trateExcelData()} name="Values">*/}
                {/*        {tratedCols.map((col) => (*/}
                {/*            <ExcelColumn*/}
                {/*                label={col.label}*/}
                {/*                value={col?.subfield ?? col.field}*/}
                {/*            />*/}
                {/*        ))}*/}
                {/*      </ExcelSheet>*/}
                {/*    </ExcelFile>*/}
                {/*)}*/}
              </div>
            </div>
          </div>
        </>
    );
  };

  const renderDefault = (value, column) => {
    return (
        <TableCell key={column.id} align={column.align}>
          <p className="text-table-servicos">{value}</p>
        </TableCell>
    );
  };

  const handleActionClick = ({
                               title,
                               content,
                               actionTitle,
                               titleSuccess,
                               msgSuccess,
                               titleError,
                               msgError,
                               reloadPage,
                             }) => {
    console.log(title);
    const Sim = 'Ok';
    const Nao = 'Não';

    const actions = {
      [Sim]: async () => {
        const response = await actionTitle();
        const innerActions = {
          [Sim]: () => console.log('Fechado'),
        };

        let configReturn;
        if (response.status === 200) {
          configReturn = {
            // Entradas
            actions: [
              {
                action: Sim,
                type: 'primary',
                color: BaSeTheme.colors.feedbackInterface.sucesso20,
              },
            ],
            title: titleSuccess,
            titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
            dismissable: true, // Quando não passar, assume-se o valor `true`
            content: () => <>{msgSuccess()}</>,
            onOpen: () => console.log('>>> Abriu a modal'),
            onChooseAction: (action) => innerActions?.[action]?.(),
            onDismiss: () =>
                console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
            afterClose: () => console.log('>>> Modal fechada'),
          };

          if (reloadPage) setActionDone(true);
        } else {
          configReturn = {
            // Entradas
            actions: [
              {
                action: Sim,
                type: 'primary',
                color: BaSeTheme.colors.feedbackInterface.sucesso20,
              },
            ],
            title: titleError,
            titleColor: BaSeTheme.colors.institucionais.erro45, // Quando não passar, assume-se o valor #617385
            dismissable: true, // Quando não passar, assume-se o valor `true`
            content: () => <>{msgError}</>,
            onOpen: () => console.log('>>> Abriu a modal'),
            onChooseAction: (action) => innerActions?.[action]?.(),
            onDismiss: () =>
                console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
            afterClose: () => console.log('>>> Modal fechada'),
          };
        }

        showModal(configReturn);
      },
    };

    const config = {
      // Entradas
      actions: [
        {
          action: Sim,
          type: 'primary',
          color: BaSeTheme.colors.feedbackInterface.sucesso20,
        },
        {
          action: Nao,
          type: 'primary',
          color: BaSeTheme.colors.feedbackInterface.erro45,
        },
      ],
      title: title,
      titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45, // Quando não passar, assume-se o valor #617385
      dismissable: true, // Quando não passar, assume-se o valor `true`
      content: () => <>{content()}</>,
      onOpen: () => console.log('>>> Abriu a modal'),
      onChooseAction: (action) => actions?.[action]?.(),
      onDismiss: () =>
          console.log('>>> Modal fechou no cancelar (ou clicando fora)'),
      afterClose: () => console.log('>>> Modal fechada'),
    };

    showModal(config);
  };

  const renderActions = (column, row) => {
    return (
        <TableCell align={column.align}>
          <div className="itens-actions">
            <FaCheck
                title={row.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar'}
                size={21}
                color={row.status === 'APROVADO' ? '#00FF00' : '#ff0000'}
                onClick={() =>
                    handleActionClick({
                      content: () => {
                        return (
                            <text>
                              Ao{' '}
                              <strong>
                                {row.status !== 'APROVADO' ? 'APROVAR' : 'DESAPROVAR'}
                              </strong>
                              {row.status !== 'APROVADO'
                                  ? ' este carrossel ele irá ser apresentado no app. Deseja continuar?'
                                  : ' este carrossel ele deixará de ser apresentado no app. Deseja continuar?'}
                            </text>
                        );
                      },
                      title: row.status === 'APROVADO' ? 'Desaprovar' : 'Aprovar',
                      actionTitle: (async) =>
                          updateCarrossel(
                              row.id,
                              row.status !== 'APROVADO' ? 'APROVADO' : 'PENDENTE'
                          ),
                      titleSuccess: 'Sucesso',
                      msgSuccess: () => (
                          <text>
                            O carrossel foi{' '}
                            <strong>
                              {row.status !== 'APROVADO' ? 'aprovado' : 'desaprovado'}
                            </strong>{' '}
                            com sucesso.
                          </text>
                      ),
                      titleError: 'Erro.',
                      msgError: () => (
                          <text>
                            O carrossel não foi{' '}
                            <strong>
                              {row.status !== 'APROVADO' ? 'aprovado' : 'desaprovado'}
                            </strong>
                            .Sistema temporariamente fora do ar. Tente novamente mais
                            tarde.
                          </text>
                      ),
                      reloadPage: true,
                    })
                }
            />
            <FaPen
                title="Editar"
                color="#6C6C6C"
                onClick={() => {
                  setTypeScreen(3);
                  setSelectedRow(row);
                }}
                size={21}
            />
            <FaCopy
                title="Copiar"
                color="#6C6C6C"
                onClick={() => {
                  setTypeScreen(4);
                  setSelectedRow(row);
                }}
                size={21}
            />
            <FaTrash
                title="Excluir"
                color="#6C6C6C"
                onClick={() =>
                    handleActionClick({
                      content: () => (
                          <text>
                            Ao <strong>excluir</strong> este carrossel, ele deixará de
                            ser apresentado no App. Deseja continuar?
                          </text>
                      ),
                      title: 'Apagar',
                      actionTitle: (async) => deleteCarrossel(row.id),
                      titleSuccess: 'Sucesso',
                      msgSuccess: () => (
                          <text>
                            O carrossel foi <strong>excluído</strong> com sucesso.
                          </text>
                      ),
                      titleError: 'Erro.',
                      msgError: () => (
                          <text>
                            O carrossel<strong> não foi excluído</strong>. Sistema
                            temporariamente fora do ar. Tente novamente mais tarde.
                          </text>
                      ),
                      reloadPage: true,
                    })
                }
                size={21}
            />
          </div>
        </TableCell>
    );
  };

  // START PAGINATION HANDLE AREA
  // ___________________________________________________________________________

  function handleLinesPerPageChange(newValue) {
    setFilters({ type: 'linesPerPage', data: newValue });
  }

  function handlePagePreviousChange(newValue) {
    if (filters.page !== 0) {
      setFilters({ type: 'page', data: filters.page - 1 });
      updateSelectedValues('page', parseInt(filtersSelectedValues?.page) - 1);
    }
  }

  function handlePageNextChange(newValue) {
    if (data.totalPages !== 0 && filters.page !== data.totalPages - 1) {
      setFilters({ type: 'page', data: filters.page + 1 });
      updateSelectedValues('page', parseInt(filtersSelectedValues?.page) + 1);
    }
  }

  function handleInputPageChange(newValue) {
    const numberValue = parseInt(newValue);
    if (
        newValue === '' ||
        (numberValue && newValue > 0 && numberValue <= data.totalPages)
    ) {
      updateSelectedValues('page', newValue);
    }
  }
  function handleOnKeyPressChange(newValue) {
    if (newValue === 'Enter') {
      if (filtersSelectedValues?.page !== '') {
        setFilters({
          type: 'page',
          data: parseInt(filtersSelectedValues?.page)
              ? filtersSelectedValues?.page - 1
              : 0,
        });
      } else {
        setFilters({ type: 'page', data: 0 });
        updateSelectedValues('page', '1');
      }
    }
  }

  // END PAGINATION HANDLE AREA
  // ___________________________________________________________________________

  const renderTable = () => {
    return (
        <div className="table-wrapper">
          {isLoading && <text>Carregando...</text>}
          {!isLoading && (
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => {
                      // const nameIcon = column.subfield
                      //   ? `${column.field}.${column.subfield}`
                      //   : column.field;

                      const nameIcon = column.field;
                      return (
                          <TableCell
                              className="table-relatorio"
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                          >
                            <div className="table-cell-container">
                              <p
                                  className="title-table-funcionalidades"
                                  style={{ color: '#33CC99' }}
                              >
                                {column.label}
                              </p>
                              {column.id !== 'status' && (
                                  <BaSeIcon
                                      name={
                                        filters.order.name === nameIcon &&
                                        filters.order.orderType
                                            ? 'angle-up'
                                            : 'angle-down'
                                      }
                                      color="#33CC99"
                                      size={24}
                                      description="Botão de ordenação"
                                      onClick={() =>
                                          setFilters({
                                            type: 'order',
                                            data: {
                                              name: nameIcon,
                                              orderType:
                                                  nameIcon === filters.order.name
                                                      ? !filters.order.orderType
                                                      : true,
                                            },
                                          })
                                      }
                                  />
                              )}
                            </div>
                          </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.content &&
                      data.content.map((row, index) => (
                          <TableRow
                              style={{
                                backgroundColor: index % 2 === 0 ? '#fff' : '#F5FBFB',
                              }}
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={index}
                          >
                            {columns.map((column) => {
                              const { id } = column;
                              const value = row[id];

                              if (id !== 'status') {
                                const finalValue = Array.isArray(value)
                                    ? value.map((elem) => elem.titulo).join()
                                    : value?.nome ?? row[id];

                                return renderDefault(
                                    column.field === 'dataCriacao' ||
                                    column.field === 'dataProximoEnvio'
                                        ? formatDateToBR(value)
                                        : finalValue,
                                    column
                                );
                              } else {
                                return renderActions(column, row);
                              }
                            })}
                          </TableRow>
                      ))}
                </TableBody>
              </Table>
          )}

          <Pagination
              color="#33CC99"
              linesPerPageFilters={filters?.linesPerPage}
              linesPerPageOptions={optionsLinesPorPage}
              filterPageSelectors={filters?.page}
              totalPages={data?.totalPages}
              filtersSelectedValues={filtersSelectedValues?.page}
              onLinesPerPageChange={handleLinesPerPageChange}
              onPagePreviousChange={handlePagePreviousChange}
              onPageNextChange={handlePageNextChange}
              onInputPageChange={handleInputPageChange}
              onKeyPressChange={handleOnKeyPressChange}
          />

          {/* <div className="pagination-container">
          <div>
            <label>Linhas por página:</label>
            <select
              style={{ color: '#33CC99' }}
              value={filters.linesPerPage}
              onChange={(e) =>
                setFilters({ type: 'linesPerPage', data: e.target.value })
              }
            >
              {optionsLinesPorPage.map((olp) => (
                <option value={olp}>{olp}</option>
              ))}
            </select>
          </div>

          <div className="icons-wrapper">
            <FaArrowCircleLeft
              color={filters.page === 0 ? '#b4b3b6' : '#33CC99'}
              onClick={() => {
                if (filters.page !== 0) {
                  setFilters({ type: 'page', data: filters.page - 1 });
                  updateSelectedValues(
                    'page',
                    parseInt(filtersSelectedValues?.page) - 1
                  );
                }
              }}
              size={24}
            />
            <FaArrowCircleRight
              color={
                data.totalPages === 0 || filters.page === data.totalPages - 1
                  ? '#b4b3b6'
                  : '#33CC99'
              }
              onClick={() => {
                if (
                  data.totalPages !== 0 &&
                  filters.page !== data.totalPages - 1
                ) {
                  setFilters({ type: 'page', data: filters.page + 1 });
                  updateSelectedValues(
                    'page',
                    parseInt(filtersSelectedValues?.page) + 1
                  );
                }
              }}
              size={24}
            />
          </div>

          <div className="pagination-container-numbers">
            <input
              value={filtersSelectedValues?.page ?? '1'}
              type="number"
              className="input-page"
              style={{ color: '#33CC99' }}
              onChange={(event) => {
                const { value } = event.target;
                const numberValue = parseInt(value);
                if (
                  value === '' ||
                  (numberValue && value > 0 && numberValue <= data.totalPages)
                )
                  updateSelectedValues('page', value);
              }}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  if (filtersSelectedValues?.page !== '') {
                    setFilters({
                      type: 'page',
                      data: parseInt(filtersSelectedValues?.page)
                        ? filtersSelectedValues?.page - 1
                        : 0,
                    });
                  } else {
                    setFilters({ type: 'page', data: 0 });
                    updateSelectedValues('page', '1');
                  }
                }
              }}
            />
            <text style={{ fontSize: 12, marginLeft: 5, color: '#b4b3b6' }}>
              de {data.totalPages}
            </text>
          </div>
        </div> */}
        </div>
    );
  };

  const renderListPage = () => {
    return (
        <div className="container-principal">
          {renderHeader()}
          {renderFiltros()}
          {renderTable()}
        </div>
    );
  };

  return (
      <>
        {error && <BaSeBackendNoSignalPage />}
        {!error && typeScreen === 1 && renderListPage()}
        {!error &&
            !isLoading &&
            (typeScreen === 2 || typeScreen === 3 || typeScreen === 4) && (
                <AddCarrossel
                    namePage="Adicionar"
                    onClose={(include) => {
                      setTypeScreen(1);
                      setActionDone(true);
                      setActionInclude(include);
                    }}
                    mainColor="#CC3467"
                    selectedRow={selectedRow}
                    allValuesOptions={allValuesOptions}
                    typeScreen={typeScreen}
                />
            )}
        {!error && !isLoading && typeScreen === 5 && (
            <ReoderCarrossel
                data={data}
                tipos={allValuesOptions?.tipos ?? []}
                onClose={() => {
                  setTypeScreen(1);
                  setActionDone(true);
                }}
            />
        )}
      </>
  );
};

export default Carrosseis;
